import { useCallback, useState } from "react";
import PrimaryButton from "../../../../../components/common/PrimaryButton";
import { IContractDetailsResponseData } from "../../../../../setup/api/services/contract/models";
import { useTranslation } from "react-i18next";

interface PartiallyPaidActionsProps {
  milestone: IContractDetailsResponseData;
}

const PartiallyPaidActions = ({ milestone }: PartiallyPaidActionsProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    const domain = window.location.hostname.split(".")[0];
    const envParts = domain.split("-");
    const env = envParts?.length === 1 ? "app" : `app-${envParts?.[1]}`;
    try {
      await navigator?.clipboard?.writeText(
        `${env}.waffyapp.com/contract/${milestone.id}`
      );

      setCopied(true);

      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      console.error(error);
    }
  }, [milestone.id]);

  return (
    <>
      <PrimaryButton
        onClick={handleCopy}
        style={{
          width: "171px",
          height: "40px",
          borderRadius: "8px",
          textAlign: "center",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          backgroundColor: copied ? "#3ECC85" : "#0d44ad",
        }}>
        {copied ? t("lbl_copied") : t("lbl_share")}
      </PrimaryButton>
    </>
  );
};

export default PartiallyPaidActions;
